import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getDay(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/attendances?${query}`, { headers: authHeader() });
    },
    saveDay(data) {
        return axios.post(`${API_URL}/attendances`, data, { headers: authHeader() });
    },
    getSummary(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/attendances/summary?${query}`, { headers: authHeader() });
    },
    getPendingDeductions(userId) {
        return axios.get(`${API_URL}/attendances/pending-deductions?user_id=${userId}`, { headers: authHeader() });
    },
    getUserHistory(userId, params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/attendances/user/${userId}?${query}`, { headers: authHeader() });
    },
};
